import React from "react";

// MerchantCore wordmark — emerald diamond mark + geometric wordmark.
export default function Logo({ className = "", showText = true }) {
  return (
    <span
      className={`inline-flex items-center gap-3 select-none ${className}`}
      aria-label="MerchantCore"
      data-testid="merchantcore-logo"
    >
      <span className="relative inline-flex h-8 w-8 shrink-0 rotate-45 items-center justify-center rounded-[7px] brand-diamond">
        <span className="h-3 w-3 -rotate-45 rounded-[2px] border-[1.5px] border-[#04120b]/70" />
      </span>
      {showText && (
        <span className="font-display text-xl font-bold leading-none tracking-tight">
          <span className="text-cloud">Merchant</span>
          <span className="text-emerald">Core</span>
        </span>
      )}
    </span>
  );
}
